import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=5dc98828&scoped=true&"
import script from "./Authorization.vue?vue&type=script&lang=ts&"
export * from "./Authorization.vue?vue&type=script&lang=ts&"
import style0 from "./Authorization.vue?vue&type=style&index=0&id=5dc98828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc98828",
  null
  
)

export default component.exports